<script>
  import { slide } from "svelte/transition"
  import { copyToClipboard } from "../../../Publish/SinglePublish/script"
  import notify from "../../../../Script/notify"

  export let user = {}

  let showAuditInfo = false

  /**
   * @typedef {Object} closeNotification
   * @property {Function} close - Closes the notification.
   */
  let closeNotification = {
    close() {},
  }

  const copyValue = async (key, value) => {
    try {
      console.log(key, value)
      closeNotification.close()
      await copyToClipboard(value)
      closeNotification = notify.info(`${key} copied successfully.`)
    } catch (error) {
      console.error(error)
      const info = `PAGE: Doc Multi-Signer (Status Page)\nEVENT: While copying ${key}`
      closeNotification = notify.danger(error, info)
    }
  }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
  on:click={() => {
    showAuditInfo = !showAuditInfo
  }}
  class="mt-2 flex cursor-pointer items-center gap-2 text-xs font-semibold text-blue-500"
>
  <span>
    <i class="fa-solid text-sm {showAuditInfo ? 'fa-circle-minus' : 'fa-circle-plus'}" />
  </span>
  <span class="underline underline-offset-4">View Audit Info</span>
</div>
{#if showAuditInfo}
  <div transition:slide class="mt-2 space-y-2 rounded-md bg-[#f7f7f7] p-3 text-xs text-black dark:bg-bodyblack dark:text-gray-50">
    <div class="space-y-1">
      <h1 class="tracking-wide">BLOCKCHAIN TXID</h1>
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <p
        on:click={() => {
          copyValue("BLOCKCHAIN TXID", user.tx)
        }}
        class="value"
      >
        {user.tx}
      </p>
    </div>
    {#if user.oHash}
      <div class="space-y-1">
        <h1 class="flex items-center justify-between">
          Original Hash
          <div data-tooltip="Original Hash Length" tooltip-position="left" class="mini-card">
            {user.oLength} bytes
          </div>
        </h1>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <p
          on:click={() => {
            copyValue("Original Hash", user.oHash)
          }}
          class="value"
        >
          {user.oHash}
        </p>
      </div>
    {/if}
    {#if user.sHash}
      <div class="space-y-1">
        <h1 class="flex items-center justify-between">
          Signed Hash
          <div data-tooltip="Signed Hash Length" tooltip-position="left" class="mini-card">
            {user.sLength} bytes
          </div>
        </h1>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <p
          on:click={() => {
            copyValue("Signed Hash", user.sHash)
          }}
          class="value"
        >
          {user.sHash}
        </p>
      </div>
    {/if}
  </div>
{/if}

<style lang="postcss">
  .value {
    word-break: break-word;
    @apply cursor-pointer font-mono text-xs font-medium text-gray-400;
  }
  .mini-card {
    @apply w-max rounded-md bg-black/25 px-2 py-1 text-gray-400;
  }
</style>
